export default "__VITE_ASSET__CQOhHYjF__"